/* eslint-disable react/require-default-props,react/prop-types */
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import enhanceWithClickOutside from 'react-click-outside';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import Icon from '../../Icon';
import Button from '../../Button';
import Paper from '../../Paper';
import Controls from '../../ContentArea/Controls';
import ControlsItem from '../../ContentArea/ControlsItem';
import { COMMON } from '../../../constants/strings';
import { COLORS } from '../../../constants/styles';
import { IDS } from '../../../constants/ids';
import styles from './index.styl';

@enhanceWithClickOutside
@CSSModules(styles, { allowMultiple: true })
export default class Dialog extends PureComponent {
  static propTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    mobileFullScreen: PropTypes.bool,
    onClose: PropTypes.func,
    strictClose: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    white: PropTypes.bool,
    contentWhite: PropTypes.bool,
    width: PropTypes.string,
    withHeading: PropTypes.bool,
    customControls: PropTypes.bool,
    submitText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    cancelText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onSubmit: PropTypes.func,
    footerCentered: PropTypes.bool,
    buttonWidth: PropTypes.number,
    isLayoutColumn: PropTypes.bool,
    submitBtnColor: PropTypes.string,
    autoHeight: PropTypes.bool,
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    withoutAdaptive: PropTypes.bool,
    dialogClassName: PropTypes.string,
    dialogHeaderContent: PropTypes.object,
    extraContentClassName: PropTypes.string,
  };

  static defaultProps = {
    mobileFullScreen: true,
    withHeading: true,
  };

  handleClickOutside(e) {
    const { onClose, strictClose } = this.props;
    !strictClose && onClose && onClose(e); // eslint-disable-line no-unused-expressions
  }

  render() {
    const {
      children,
      mobileFullScreen,
      onClose,
      title,
      white,
      contentWhite,
      contentNoPadding,
      width,
      withHeading,
      controls,
      onAdd,
      enabled,
      customControls,
      submitText,
      cancelText,
      onSubmit,
      footerCentered,
      footerEnd,
      buttonWidth,
      isLayoutColumn,
      submitBtnColor,
      overflowVisible,
      autoHeight,
      subTitle,
      withoutAdaptive,
      dialogClassName,
      paperClassName,
      dialogHeaderContent,
      extraContentClassName,
    } = this.props;

    return (
      <div
        className={dialogClassName}
        styleName={cn('root', {
          'root--nonAdaptive': !mobileFullScreen,
          'root--overflow-visible': overflowVisible,
          [`root--width--${width}`]: width,
        })}
      >
        <Paper
          gray={!white}
          className={paperClassName}
          isLayoutColumn={isLayoutColumn}
          overflowVisible={overflowVisible}
        >
          <If condition={withHeading || title}>
            <header styleName="header">
              <Controls className="w-100 h-100 ph2 pt2">
                <ControlsItem>
                  <If condition={title}>
                    <h1 children={title} className="ph2" styleName="title" />
                  </If>
                </ControlsItem>
                <ControlsItem fixed>
                  <Button
                    id={IDS.COMMON.DIALOG_CLOSE}
                    icon
                    onClick={onClose}
                    ariaLabel="close"
                  >
                    <Icon name="close" style={{ stroke: COLORS.bluePrimary }} />
                  </Button>
                </ControlsItem>
              </Controls>
            </header>
            <Fragment>{dialogHeaderContent && dialogHeaderContent}</Fragment>
            <If condition={title && subTitle}>
              <div children={subTitle} styleName="subTitle" />
            </If>
          </If>
          <div
            styleName={cn('content', {
              'content--full-height': !controls && !customControls,
              'content--white': contentWhite,
              'content--noPadding': contentNoPadding,
              'content--auto-height': autoHeight,
              contentWithoutAdaptive: withoutAdaptive,
            })}
            className={extraContentClassName}
          >
            {children}
          </div>
          <If condition={controls}>
            <footer styleName="footer">
              <Button
                id={IDS.COMMON.DIALOG_OK}
                disabled={!enabled}
                className="mr3"
                raised
                color="primary"
                onClick={onAdd}
              >
                <FormattedMessage {...COMMON.add} />
              </Button>
              <Button
                id={IDS.COMMON.DIALOG_CLOSE}
                raised
                color="accent"
                onClick={onClose}
              >
                <FormattedMessage {...COMMON.cancel} />
              </Button>
            </footer>
          </If>
          <If condition={customControls}>
            <footer
              styleName={cn('footer', {
                'footer--centered': footerCentered,
                'footer--end': footerEnd,
              })}
            >
              <Button
                id={IDS.COMMON.DIALOG_OK}
                disabled={!enabled}
                className={footerCentered ? null : 'mr3'}
                raised
                color={submitBtnColor || 'primary'}
                onClick={onSubmit}
                style={{ minWidth: buttonWidth || null }}
              >
                {submitText}
              </Button>
              {cancelText && (
                <Button
                  id={IDS.COMMON.DIALOG_CLOSE}
                  raised
                  color="accent"
                  onClick={onClose}
                >
                  {cancelText}
                </Button>
              )}
            </footer>
          </If>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Dialog/index.jsx